export const normalizeConsentRenewAgree = (rawData) => {
  return {
    isAlreadyAgree: rawData?.is_already_agree ?? false,
    consentDate: rawData?.consent_date ?? '',
  }
}
